<template>
  <span :class="badgeClasses">
    <slot />
  </span>
</template>

<script>
export default {
  name: 'BaseBadge',
  props: {
    variant: {
      type: String,
      default: 'default',
      validator: (v) => ['default', 'primary', 'success', 'warning', 'danger', 'info'].includes(v),
    },
    size: {
      type: String,
      default: 'md',
      validator: (v) => ['sm', 'md'].includes(v),
    },
  },
  computed: {
    badgeClasses() {
      const base = 'inline-flex items-center font-medium rounded-full'
      const sizes = { sm: 'text-xs px-2 py-0.5', md: 'text-xs px-2.5 py-1' }
      const variants = {
        default: 'bg-border-subtle text-muted',
        primary: 'bg-primary-muted text-primary',
        success: 'bg-success/10 text-success',
        warning: 'bg-warning/10 text-warning',
        danger: 'bg-danger/10 text-danger',
        info: 'bg-info/10 text-info',
      }
      return [base, sizes[this.size], variants[this.variant]]
    },
  },
}
</script>
